import React, { useEffect } from "react";
import Attendees from "../components/Attendees";
import { useParams } from "react-router-dom";
import useEventState from "../hooks/eventHooks";
import { CiExport } from "react-icons/ci";

function AttendeesPage() {
  const { event } = useParams();
  const { getAttendees, attendees, getAttendeesCSV, dataCSV, CSVFileName } =
    useEventState();
  useEffect(() => {
    getAttendees(event);
    getAttendeesCSV(event);
  }, []);

  return (
    <div className="p-6">
      <div className="flex justify-between items-center">
        <h2 className="font-bold text-xl my-7">{event}</h2>
        {dataCSV && (
          <a
            className="border flex space-x-2 w-32 h-12 items-center justify-center text-white bg-green-50 text-lg"
            href={`data:text/csv;charset=utf-8,${escape(dataCSV.data)}`}
            download={CSVFileName}
          >
            <CiExport className="font-bold" />
            <p>Export</p>
          </a>
        )}
      </div>
      <Attendees attendees={attendees} />
    </div>
  );
}

export default AttendeesPage;
